// extracted by mini-css-extract-plugin
export default {"wrapper":"FullScreenWrapper_wrapper__niArt","close":"FullScreenWrapper_close__2Rrqj"};